module.exports = __webpack_public_path__ + "static/media/campingset.8952b19b.svg";